import * as React from "react"
import {Box} from "@chakra-ui/react";

export default function Separator(props){
    return(
        <Box as={'span'} display={'inline-block'} margin='0 30px' width={'1px'} height={'40px'} background={'#DBE1EA'}  {...props}></Box>
    )
}